module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Ahr-4377c5ff4720e4e8bc9433576aee261b.jpg";